export default __webpack_public_path__ + "static/media/ge.73b95d44.svg";